import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Row, Col, Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { editInscription, getInscriptionsByClub } from '../../../../actions/activities/inscriptionsActions'
import { CustomDataTable } from '../../../../components/design/Datatables/CustomDataTable'
import ActivitiesSubMenu from '../../../../components/menus/ActivitiesSubMenu'
import InscriptionSummary from '../../../../components/Activities/InscriptionSummary'
import useAuth from '../../../../context/auth/useAuth'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import ClubBreadCrumbs from '../../../../components/breadcrumbs/ClubBreadCrumbs'
import Loader from '../../../../components/design/Loader/Loader'

export default function InscriptionsCanceled({usertype, inscriptionselected, handleInscriptionSelect}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
	const {clientauth} = useAuth()

    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const {inscriptions, loadinginscriptions} = useSelector(state=>state.inscriptions)
    const {club} = useSelector(state=>state.clubs)

    const [typeform, setTypeform] = useState(null)

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(clientauth){
            dispatch(getInscriptionsByClub(club?._id,true))
        }
    },[dispatch, t, clientauth, club])

    const handleSelectChange = (inscription, value) => {
        if(value==='3'){
            Swal.fire({
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: t('global.yes'),
                cancelButtonText: t('global.no'),
                icon: 'warning',
                text: t('inscriptions.cancelSecure')
            }).then((newresult) => {
                if (newresult.isConfirmed) {
                    dispatch(editInscription(inscription, value, 'status', 'club'))
                }
            })
        }else{
            dispatch(editInscription(inscription, value, 'status', 'club'))
        }
    }

    const columnsInscriptions = [
        {
            name: t('inscriptions.client'),
            cell: inscription =>
                <Link
                    onClick={() => {
                        handleInscriptionSelect(inscription._id)
                        setShow(true)
                    }}
                    className='table-link'>
                    {inscription?.client?.firstname} {inscription?.client?.lastname}
                </Link>,
            selector: (inscription) => inscription.firstname+' '+inscription.lastname,
            sortable: true,
        },{
            name: <>{t('groups.activity')} / {t('groups.category')}</>,
            cell: inscription =>
                <Link
                    onClick={() => {
                        handleInscriptionSelect(inscription._id)
                        setShow(true)
                    }}
                    className='table-link'>
                    {inscription?.activity?.title} / {inscription?.category?.title}
                </Link>,
            selector: (inscription) => inscription?.activity?.title+' '+inscription?.category?.title,
            sortable: true,
        },{
            name: <>{t('inscriptions.group')} / {t('inscriptions.horary')}</>,
            cell: inscription =>
                <>{inscription?.group?.title} / {inscription?.horary?.name}</>,
            selector: (inscription) => inscription?.group?.title+' '+inscription?.horary?.name,
            sortable: true,
        },{
            name: t('inscriptions.status'),
            center: 'true',
            cell: inscription =>
                t('inscriptions.status'+inscription?.status),
            selector: (inscription) => inscription?.group?.title,
            sortable: true,
        },{
            name: t('inscriptions.paymentStatus'),
            center: 'true',
            cell: inscription =>
                !inscription.paymentStatus && inscription.paymentStatus !== 0
                    ?
                        <></>
                    :
                        <span className={`p-2 text-white ${inscription.paymentStatus === 0 ? 'bg-success' : inscription.paymentStatus === 1 ? 'bg-warning' : 'bg-danger'}`}>
                            {
                                inscription.paymentStatus === 0
                                    ?
                                        <i className='fas fa-check'/>
                                    :
                                        inscription.paymentStatus === 1
                                            ?
                                                <i className='fas fa-clock'/>
                                            :
                                                <i className='fas fa-x'/>
                            }
                        </span>
            ,
            selector: (inscription) => inscription.paymentStatus === 0 ? 'success' : inscription.paymentStatus === 1 ? 'warning' : 'danger',
            sortable: false,
        },{
            name: t('inscriptions.actions'),
            center: 'true',
            width:'120px',
            cell: inscription =>
                <div className='d-flex w-100'>
                    <Link
                        onClick={() => {
                            handleInscriptionSelect(inscription._id)
                            setTypeform('view')
                            setShow(true)
                        }}
                        className='table-link me-2'>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">{t('inscriptions.seeinscription')}</Tooltip>}
                        >
                            <img className="cursor" src="/images/eyeopen.svg" alt="eyes" height={16}/>
                        </OverlayTrigger>
                    </Link>
                    <Link
                        onClick={() => {
                            handleInscriptionSelect(inscription._id)
                            setTypeform('edit')
                            setShow(true)
                        }}
                        className='table-link'>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">{t('inscriptions.editinscription')}</Tooltip>}
                        >
                            <img className="cursor" src="/images/pencil.svg" alt="pencil" height={16}/>
                        </OverlayTrigger>
                    </Link>
                    {inscription?.status === "0" || inscription?.status === "4" ?
                        <>
                            <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip">{t('inscriptions.approveinscription')}</Tooltip>}
                            >
                                <i className="fas fa-check px-2 cursor" onClick={() => handleSelectChange(inscription?._id, "1")}></i>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip">{t('inscriptions.cancelinscription')}</Tooltip>}
                            >
                                <i className="fas fa-xmark px-2 cursor" onClick={() => handleSelectChange(inscription?._id, "3")}></i>
                            </OverlayTrigger>
                        </>
                    :
                        inscription?.status !== "3" ?
                            <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip">{t('inscriptions.cancelinscription')}</Tooltip>}
                            >
                                <i className="fas fa-xmark px-2 cursor" onClick={() => handleSelectChange(inscription?._id, "3")}></i>
                            </OverlayTrigger>
                        :
                            ''
                    }
                </div>,
            selector: (inscription) => inscription?.group?.title,
            sortable: false,
        }
	]


    return (
        <>
            <Container className='cuerpo'>
                <ClubBreadCrumbs usertype={usertype} club={club} />
                <Row>
                    <Col className='d-flex align-items-center'>
                        <h1 className='ms-2 my-0'>{t('menus.activities.inscriptions')}</h1>
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col>
                        <ActivitiesSubMenu usertype={usertype} active="inscriptionscanceled"/>
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col>
                        <Card>
                            {loadinginscriptions
                            ?
                                <Loader/>
                            :
                                <Card.Body>
                                    <div className="my-3">
                                        <Row>
                                            <Col>
                                                {inscriptions?.length > 0 ?
                                                    <CustomDataTable columns={columnsInscriptions} data={inscriptions} exportable={false} printable={false} />
                                                :
                                                    <div className='contenedor-vacio text-center'>
                                                        <h4>{t('inscriptions.thereisnotinscriptions')}</h4>
                                                        {t('inscriptions.thereisnotinscriptionsphrase')}
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                </Card.Body>
                            }
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h2>{t('inscriptions.datainscription')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='cuerpo px-5 py-4'>
                    <InscriptionSummary usertype={usertype} typeform={typeform} inscriptionselected={inscriptionselected}/>
                </Modal.Body>
            </Modal>
        </>
    )
}